var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 337,
    viewBox: "0 0 230 337",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 25,
    r: 4,
    fill: "#B3B3B3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.8,
    cy: 25,
    r: 4,
    fill: "#B3B3B3"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.6,
    cy: 25,
    r: 4,
    fill: "#B3B3B3"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.4,
    cy: 25,
    r: 4,
    fill: "#B3B3B3"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 202.2,
    cy: 25,
    r: 4,
    fill: "#B3B3B3"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 72.7139,
    r: 4,
    fill: "#B3B3B3"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.8,
    cy: 72.7139,
    r: 4,
    fill: "#B3B3B3"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.6,
    cy: 72.7139,
    r: 4,
    fill: "#B3B3B3"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.4,
    cy: 72.7139,
    r: 4,
    fill: "#B3B3B3"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 202.201,
    cy: 72.7139,
    r: 4,
    fill: "#B3B3B3"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 120.428,
    r: 4,
    fill: "#B3B3B3"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.8,
    cy: 120.428,
    r: 4,
    fill: "#B3B3B3"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.6,
    cy: 120.428,
    r: 4,
    fill: "#B3B3B3"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.4,
    cy: 120.428,
    r: 4,
    fill: "#B3B3B3"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 202.201,
    cy: 120.428,
    r: 4,
    fill: "#B3B3B3"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 168.142,
    r: 4,
    fill: "#B3B3B3"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.8,
    cy: 168.142,
    r: 4,
    fill: "#B3B3B3"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.6,
    cy: 168.142,
    r: 4,
    fill: "#B3B3B3"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.4,
    cy: 168.142,
    r: 4,
    fill: "#B3B3B3"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 202.201,
    cy: 168.142,
    r: 4,
    fill: "#B3B3B3"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 215.855,
    r: 4,
    fill: "#BA1F1A",
    fillOpacity: 0.42
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.8,
    cy: 215.855,
    r: 4,
    fill: "#BA1F1A",
    fillOpacity: 0.42
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.6,
    cy: 215.855,
    r: 4,
    fill: "#BA1F1A",
    fillOpacity: 0.42
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.4,
    cy: 215.855,
    r: 4,
    fill: "#BA1F1A",
    fillOpacity: 0.42
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 202.201,
    cy: 215.855,
    r: 4,
    fill: "#BA1F1A",
    fillOpacity: 0.42
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 263.569,
    r: 4,
    fill: "#BA1F1A",
    fillOpacity: 0.42
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.8,
    cy: 263.569,
    r: 4,
    fill: "#BA1F1A",
    fillOpacity: 0.42
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.6,
    cy: 263.569,
    r: 4,
    fill: "#BA1F1A",
    fillOpacity: 0.42
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.4,
    cy: 263.569,
    r: 4,
    fill: "#BA1F1A",
    fillOpacity: 0.42
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 202.201,
    cy: 263.569,
    r: 4,
    fill: "#BA1F1A",
    fillOpacity: 0.42
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 311.283,
    r: 4,
    fill: "#BA1F1A",
    fillOpacity: 0.42
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.8,
    cy: 311.283,
    r: 4,
    fill: "#BA1F1A",
    fillOpacity: 0.42
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.6,
    cy: 311.283,
    r: 4,
    fill: "#BA1F1A",
    fillOpacity: 0.42
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.4,
    cy: 311.283,
    r: 4,
    fill: "#BA1F1A",
    fillOpacity: 0.42
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 202.201,
    cy: 311.283,
    r: 4,
    fill: "#BA1F1A",
    fillOpacity: 0.42
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDot);
export default __webpack_public_path__ + "static/media/dot.0d3f622fbeef23ca09299ba7152557ae.svg";
export { ForwardRef as ReactComponent };